import { ModelBase } from '../../core/model/model-base';

export class ExecutorGroup extends ModelBase {
  constructor(dataContext?: any) {
    super();
    if (dataContext) {
      this.id = dataContext.id;
      this.name = dataContext.name;
    }
  }

  name: string;

  toString() {
    if (!this.name) {
      return '';
    }
    return `${this.name}`;
  }
}
